<script setup lang="ts">
import { ref, provide, defineProps } from 'vue';
const props = defineProps<{ type?: 'single' | 'multiple'; collapsible?: boolean }>();

const openValue = ref<string | null>(null);

function toggle(value: string) {
  if (props.type === 'single') {
    if (openValue.value === value && props.collapsible) {
      openValue.value = null;
    } else {
      openValue.value = value;
    }
  } else {
    // multiple - tutaj ewentualna logika dla multi accordion
  }
}

provide('openValue', openValue);
provide('toggle', toggle);
</script>

<template>
  <div>
    <slot></slot>
  </div>
</template>
